'use es6';

import PropTypes from 'prop-types';
import { Record } from 'immutable';
import { View } from 'foundations-components/components/View';
import bestContrastColor from 'feedback-utils/bestContrastColor';
import { renderStyledTagText } from 'feedback-shared-ui/tokens';
import { Selectors } from '../../Constants';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
const Callout = ({
  config,
  onExpand,
  contactProperties
}) => {
  const {
    calloutText,
    question,
    themeColor
  } = config;
  return /*#__PURE__*/_jsx("div", {
    className: "callout-page",
    "data-selenium-test": Selectors.HOMEPAGE,
    onClick: onExpand,
    children: /*#__PURE__*/_jsx("div", {
      className: "heading",
      "data-selenium-test": Selectors.CALLOUT,
      style: {
        backgroundColor: themeColor,
        color: bestContrastColor(themeColor)
      },
      children: /*#__PURE__*/_jsx(View, {
        inlineSize: "100%",
        "data-selenium-test": "token-preview-tag-SURVEY_QUESTION",
        children: /*#__PURE__*/_jsx(NavMarker, {
          name: "callout",
          children: question && contactProperties && renderStyledTagText(calloutText || question, contactProperties, {
            className: 'align-center',
            singleLine: true
          }) || /*#__PURE__*/_jsx("div", {
            children: "\xA0"
          })
        })
      })
    })
  });
};
Callout.propTypes = {
  config: PropTypes.instanceOf(Record).isRequired,
  onExpand: PropTypes.func.isRequired,
  contactProperties: PropTypes.instanceOf(Record)
};
export default Callout;